export * from './colors.constant';
export * from './rating-colors.constant';
export * from './program-type-list.constant';
export * from './validation-errors.constant';
export * from './target-site-program.constant';
export * from './instance-number.constant';
export * from './active-directory.constant';
export * from './skills-or-performance-categories.constant';
export * from './auth.constant';
export * from './owl-date-picker-config.constant';
export * from './froala-editor-config.constant';
export * from './icons-constants';
export * from './app-constants';
export * from './text-constants';

export const DRAGGABLE_AREA = 'draggable-area';
export const SUPPORT_EMAIL = 'support@powerdms.com';
export const UNSAVED_CHANGES_WARNING = 'The changes added will not be saved. Are you sure you want to cancel?';
